import { Component, OnInit, ViewEncapsulation, inject } from '@angular/core';
import { CoreService } from '@portal-client/core/core.service';
import { Observable } from 'rxjs';
import { MatToolbar } from '@angular/material/toolbar';
import { NavbarHelpButtonComponent } from '@portal-core/layout/components/navbar-help-button/navbar-help-button.component';
import { AsyncPipe } from '@angular/common';

@Component({
    selector: 'mc-app-navbar-logged-out-launch-pad',
    templateUrl: './app-navbar-logged-out-launch-pad.component.html',
    styleUrls: ['./app-navbar-logged-out-launch-pad.component.scss'],
    encapsulation: ViewEncapsulation.None,
    imports: [MatToolbar, NavbarHelpButtonComponent, AsyncPipe]
})
export class AppNavbarLoggedOutLaunchPadComponent implements OnInit {
  private readonly coreService = inject(CoreService);

  appVersionAndBuildDate$: Observable<string>;

  ngOnInit() {
    this.appVersionAndBuildDate$ = this.coreService.getVersionAndBuildDate$();
  }
}
